// @ts-strict-ignore
import Link from 'next/link'
import { ReactElement } from 'react'

import {
	HeroInfoTriggers,
	HeroInfoTriggersProps
} from '@/widgets/HeroInfoBlock/ui/components/HeroInfoTriggers/HeroInfoTriggers'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { Button } from '@/shared/ui'
import Flex from '@/shared/ui/Flex'

import styles from './HeroInfoContent.module.scss'

export type HeroInfoContentProps = {
	title: string
	subtitle?: string
	customSubtitle?: ReactElement
	items?: HeroInfoTriggersProps[`items`]
	buttonText?: string
	buttonAnchor?: string
	customButton?: ReactElement
	noteText?: string
	secondButtonText?: string
	secondButtonAnchor?: string
	imgWidth?: number | undefined
	imgHeight?: number | undefined
	titlePosition?: `center` | `start` | `end`
	topSubtitle?: string | ReactElement
}

/**
 * Content part of HeroInfoBlock
 * @param title
 * @param subtitle
 * @param items - trigger item list
 * @param buttonText - text of main button
 * @param buttonAnchor - link of main button
 * @param customButton - button with no-link functionality
 * @param secondButtonText - text of second button
 * @param secondButtonAnchor - link of second button
 * @param noteText - text for note
 * @param customSubtitle - sub note for subtitle
 * @param titlePosition - title  align
 * @param topSubtitle
 */
export const HeroInfoContent = ({
	title,
	subtitle,
	items,
	buttonText,
	buttonAnchor = ``,
	customButton,
	secondButtonText,
	secondButtonAnchor,
	noteText,
	customSubtitle,
	titlePosition,
	topSubtitle
}: HeroInfoContentProps): JSX.Element => (
	<div className={styles.heroInfoContent}>
		<Flex column>
			{topSubtitle && <p className={styles.blueSubtitle}>{topSubtitle}</p>}
			<h1
				className={`${styles.title} ${titlePosition ? styles[titlePosition] : ''}`}
				dangerouslySetInnerHTML={createMarkup(title)}
			/>
			<p className={styles.subtitle} dangerouslySetInnerHTML={createMarkup(subtitle)} />
			{customSubtitle}
			{items && <HeroInfoTriggers items={items} />}

			<Flex alignCenter>
				{customButton && customButton}
				{!customButton && buttonText && (
					<Button className={styles.scrollButton} as="a" href={buttonAnchor} theme="primary">
						{buttonText}
					</Button>
				)}

				{secondButtonText && secondButtonAnchor && (
					<Link prefetch={false} href={secondButtonAnchor} className={styles.secondButton}>
						{secondButtonText}
					</Link>
				)}
			</Flex>

			{noteText && <span className={styles.note} dangerouslySetInnerHTML={createMarkup(noteText)} />}
		</Flex>
	</div>
)
